import { attribute, create, clickable, collection, isPresent, text, visitable } from 'ember-cli-page-object';
import flashMessage from 'core/test-support/pages/components/flash-message';
import ModalAction from 'vagrant/test-support/pages/components/modal/action';
import ModalConfirm from 'core/test-support/pages/components/modal-confirm';
export default create({
  visit: visitable('/private/registries/:registry/boxes/'),
  title: text('[data-test-title]'),
  create: clickable('[data-test-vagrant-box-create]'),
  canCreate: isPresent('[data-test-vagrant-box-create]'),
  manage: clickable('[data-test-manage-trigger]'),
  isManageable: isPresent('[data-test-manage]'),
  manageActions: collection('[data-test-manage] [data-test-manage-action]', {
    action: attribute('data-test-manage-action')
  }),
  boxes: collection('[data-test-boxes] tbody tr', {
    name: text('[data-test-box-link]'),
    hasBadge: isPresent('td:eq(0) .hds-badge'),
    badge: text('td:eq(0) .hds-badge'),
    status: text('td:eq(1)'),
    created: text('td:eq(2)'),
    downloads: text('td:eq(3)'),
    versions: text('td:eq(4)'),
    providers: collection('td:eq(5) .hds-badge'),
    visit: clickable('td:eq(0) a')
  }),
  error: {
    scope: '[data-test-http-error-container]',
    title: text('[data-test-http-error-state-title]'),
    content: text('[data-test-http-error-state-content]'),
    goto: clickable('[data-test-http-error-state-footer] [data-test-error-link]')
  },
  async action(name) {
    const action = this.manageActions.findOneBy('action', name);
    if (!action) throw new Error(`No action with name ${name}`);
    await action.click();
  },
  hasAction(name) {
    return !!this.manageActions.toArray().find(obj => obj.action === name);
  },
  deleteModal: ModalAction('[data-test-version-delete-modal]', {
    ...ModalConfirm
  }),
  flash: flashMessage
});